// import React, { useEffect, useState, useRef, useCallback } from "react";
// import Styles from "../../styles/session/session.module.scss";
// import Navbar from "../../components/Navbar";
// import Create from "../../assets/session/create.png";
// import Save from "../../assets/session/save.png";
// import Duplicate_Image_URL from "../../assets/session/duplicate_dark.png";
// import Delete from "../../assets/session/delete.png";
// import { useNavigate, useParams } from "react-router-dom";
// import { adminRoutes } from "../../routers/AdminRouters";
// import { Link } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   deleteSession,
//   deleteSessionFormat,
//   getFormatSessionById,
//   getSession,
//   getSessionById,
//   getSessionFormatById,
// } from "../../services";
// import Close_Button from "../../assets/auth/close.png";
// import Suceess from "../../assets/session/deletepopup.png";
// import Edit from "../../assets/exersise/pencil-edit.png";
// import Swal from "sweetalert2";
// import { toggle } from "../../redux";
// const capitalizeEachWord = (string) => {
//   if (!string) return ""; // Handle empty or undefined strings
//   return string
//     .split(" ") // Split into words
//     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
//     .join(" "); // Join back into a string
// };

// const FormatList = () => {
//   const { sessions } = useSelector((state) => state.sessions);
//   const { session } = useSelector((state) => state.sessions);
//   const isSidebarOpen = useSelector((state) => state.navbar.button);
//   const { sessionFormats } = useSelector((state) => state.sessionFormats);
//   const { sessionId } = useParams();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [displayedSessions, setDisplayedSessions] = useState([]);
//   const [hasMore, setHasMore] = useState(true);
//   const [page, setPage] = useState(1);
//   const loader = useRef(null);
//   const itemsPerLoad = 5;

//   useEffect(() => {
//     if (sessionId) {
//       getSessionFormatById(sessionId);
//       getSessionById(sessionId);
//     }
//   }, [sessionId]);
//   console.log(session,"session");

//   useEffect(() => {
//     if (!sessionStorage.getItem("reloaded")) {
//       sessionStorage.setItem("reloaded", "true");
//       window.location.reload();
//     }
//   }, []);

//   const handleMainContainerClick = () => {
//     if (isSidebarOpen) {
//       dispatch(toggle());
//     }
//   };

//   useEffect(() => {
//     if (sessions.length > 0) {
//       setDisplayedSessions(sessions.slice(0, itemsPerLoad));
//       setHasMore(sessions.length > itemsPerLoad);
//     }
//   }, [sessions]);

//   const handleObserver = useCallback(
//     (entries) => {
//       const target = entries[0];
//       if (target.isIntersecting && hasMore) {
//         setPage((prev) => prev + 1);
//       }
//     },
//     [hasMore]
//   );

//   useEffect(() => {
//     const option = {
//       root: null,
//       rootMargin: "20px",
//       threshold: 0,
//     };
//     const observer = new IntersectionObserver(handleObserver, option);
//     if (loader.current) observer.observe(loader.current);

//     return () => {
//       if (loader.current) observer.unobserve(loader.current);
//     };
//   }, [handleObserver]);

//   useEffect(() => {
//     const startIndex = (page - 1) * itemsPerLoad;
//     const endIndex = startIndex + itemsPerLoad;

//     if (startIndex < sessions.length) {
//       const newSessions = sessions.slice(0, endIndex);
//       setDisplayedSessions(newSessions);
//       setHasMore(endIndex < sessions.length);
//     }
//   }, [page, sessions]);

//   const handleEditFormat = (formatId) => {
//     navigate(`${adminRoutes.editFormat.replace(":formatId", formatId)}`, {
//       state: { sessionId },
//     });
//   };

//   const handleDelete = (id) => {
//     Swal.fire({
//       html: `
//         <div style="text-align: center; border-radius: 20px; position: relative;">
//           <button
//             id="customCloseButton"
//             style="position: absolute; top:-5px; right:-10px; background: none; border: none; cursor: pointer;">
//             <img
//               src=${Close_Button}
//               alt="Close"
//               style="width: 40px; height: 40px;"
//             />
//           </button>
//           <img
//             src=${Suceess}
//             alt="Success"
//             style="width: 100px; margin-bottom: 10px; margin-top: 15px;"
//           />
//           <h2 style="color:#151515;text-align:center;font-family:gothambold; font-size:18px;margin-bottom: 10px; ">Are you sure?</h2>
//           <p style="color:#2E292A;text-align:center;font-family:gotham_bookregular; line-height:22px; font-size:14px;margin-bottom: 10px; ">
//             Do you really want to delete these details? This process cannot be undone.
//           </p>
//           <button
//             id="cancel"
//             style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border: none; border-radius: 6px; cursor: pointer; margin-top: 10px;">
//             Cancel
//           </button>
//           <br/>
//           <button
//             id="delete"
//             style="background: #800505; color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border-radius: 6px; cursor: pointer; margin-top: 10px;">
//             Delete
//           </button>
//         </div>
//       `,
//       showConfirmButton: false,
//       width: "400px",
//       customClass: {
//         popup: "custom-swal-container",
//       },
//       didOpen: () => {
//         const cancel = document.getElementById("cancel");
//         const deleteButton = document.getElementById("delete");
//         const closeButton = document.getElementById("customCloseButton");

//         cancel.addEventListener("click", () => {
//           Swal.close();
//         });
//         deleteButton.addEventListener("click", () => {
//           Swal.close();
//           deleteSessionFormat(id);
//           navigate(
//             `${adminRoutes.listFormat.replace(":sessionId", sessionId)}`
//           );
//         });

//         closeButton.addEventListener("click", () => {
//           Swal.close();
//         });
//       },
//     });
//   };

//   const handleCreateNewFormat = (sessionId) => {
//     navigate(adminRoutes.assignFormatFirst.replace(":sessionId", sessionId));
//   };

//   return (
//     <>
//       <Navbar />
//       <div
//         className={Styles.session_list_container}
//         onClick={handleMainContainerClick}
//       >
//         <h2>
//           <Link to={adminRoutes.dashboard} className={Styles.dark}>
//             HOME /
//           </Link>{" "}
//           <Link to={adminRoutes.listSession} className={Styles.white}>
//             {session?.name} /
//           </Link>{" "}
//           <span>FORMATS</span>
//         </h2>
//         <div className={Styles.table_container_main}>
//           <div className={Styles.table_container}>
//             <div className={Styles.table_container_heading}>
//               <div className={Styles.table_container_headingone}>
//                 <h3>FORMAT &nbsp;LIST</h3>
//               </div>
//               <div className={Styles.table_container_headingtwo}>
//                 <div
//                   className={Styles.duplicate}
//                   onClick={() => handleCreateNewFormat(sessionId)}
//                   style={{ cursor: "pointer" }}
//                 >
//                   <img
//                     src={Create}
//                     alt="Duplicate Icon"
//                     className={Styles.icon}
//                   />
//                   Create New Format{" "}
//                 </div>
//               </div>
//             </div>
//             <table>
//               <thead>
//                 <tr>
//                   <th
//                     style={{
//                       paddingTop: "1em",
//                       paddingBottom: "1em",
//                       width: "20vw",
//                     }}
//                   >
//                     Format
//                   </th>
//                   <th
//                     style={{
//                       paddingTop: "1em",
//                       paddingBottom: "1em",
//                       width: "20vw",
//                     }}
//                   >
//                     Sub Format
//                   </th>
//                   <th
//                     style={{
//                       paddingTop: "1em",
//                       paddingBottom: "1em",
//                       width: "40vw",
//                     }}
//                   >
//                     Exercise Name
//                   </th>
//                   <th
//                     style={{
//                       paddingTop: "1em",
//                       paddingBottom: "1em",
//                       width: "20vw",
//                     }}
//                     className={Styles.actions_column}
//                   >
//                     <div className={Styles.action_column_inner}>
//                       <div className={Styles.action_column_inner_child}>
//                         Actions
//                       </div>
//                     </div>
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {sessionFormats.length > 0 ? (
//                   sessionFormats.map((session, index) => (
//                     <tr key={session?._id || index}>
//                       <td >{capitalizeEachWord(session?.format?.name) || "N/A"}</td>
//                       <td>{capitalizeEachWord(session?.subFormat) || ""}</td>
//                       <td>
//                         {session.exercises?.length > 0
//                           ? session.exercises.map((exercise) => (
//                               <span
//                                 key={exercise._id}
//                                 style={{
//                                   display: "inline-block",
//                                   marginRight: "2px",
//                                   marginBottom: "6px",
//                                 }}
//                               >
//                                 {exercise.exercise?.name || " "}
//                               </span>
//                             ))
//                           : "No Exercises"}
//                       </td>
//                       <td className={Styles.action_buttons}>
//                         <button
//                           className={Styles.edit}
//                           onClick={() => handleEditFormat(session._id)}
//                         >
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             width="20"
//                             height="20"
//                             viewBox="0 0 20 20"
//                             fill="none"
//                           >
//                             <path
//                               d="M12.6786 4.98549L13.8467 3.81735C14.4918 3.17221 15.5378 3.17221 16.183 3.81735C16.8281 4.46249 16.8281 5.50848 16.183 6.15362L15.0148 7.32175M12.6786 4.98549L5.81702 11.8471C4.94594 12.7182 4.51038 13.1537 4.2138 13.6844C3.91722 14.2152 3.61883 15.4684 3.3335 16.6668C4.5319 16.3815 5.78515 16.0831 6.3159 15.7865C6.84665 15.4899 7.2822 15.0544 8.15329 14.1833L15.0148 7.32175M12.6786 4.98549L15.0148 7.32175"
//                               stroke="#F3F3F6"
//                               stroke-width="1.25"
//                               stroke-linecap="round"
//                               stroke-linejoin="round"
//                             />
//                             <path
//                               d="M9.1665 16.6665H14.1665"
//                               stroke="#F3F3F6"
//                               stroke-width="1.25"
//                               stroke-linecap="round"
//                             />
//                           </svg>
//                           Edit Format
//                         </button>
//                         <button
//                           className={Styles.delete}
//                           onClick={() => handleDelete(session._id)}
//                         >
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             width="10"
//                             height="10"
//                             viewBox="0 0 10 10"
//                             fill="none"
//                             style={{ marginRight: "5px" }}
//                           >
//                             <path
//                               d="M9.16667 0.916504L1 9.08318M1 0.916504L9.16667 9.08318"
//                               stroke="#F3F3F6"
//                               stroke-width="1.5"
//                               stroke-linecap="round"
//                               stroke-linejoin="round"
//                             />
//                           </svg>
//                           Delete
//                         </button>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td
//                       colSpan="4"
//                       style={{ textAlign: "center", padding: "1em" }}
//                     >
//                       <h5 id={Styles.formatmsg}>No formats available.</h5>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default FormatList;






import React, { useEffect, useState } from "react";
import Styles from "../../styles/session/session.module.scss";
import Navbar from "../../components/Navbar";
import Create from "../../assets/session/create.png";
import { useNavigate, useParams } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteSessionFormat,
  getSessionById,
  getSessionFormatById,
} from "../../services";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/session/deletepopup.png";
import Edit from "../../assets/exersise/pencil-edit.png";
import Swal from "sweetalert2";
import { toggle } from "../../redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { FaSearch } from "react-icons/fa";

const capitalizeEachWord = (string) => {
  if (!string) return ""; // Handle empty or undefined strings
  return string
    .split(" ") // Split into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
    .join(" "); // Join back into a string
};
const LIMIT = 7;
const FormatList = () => {
  const { sessions } = useSelector((state) => state.sessions);
  const { session } = useSelector((state) => state.sessions);
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const { sessionFormats } = useSelector((state) => state.sessionFormats);
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [displayedFormats, setDisplayedFormats] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("oldest");
  const [searchQuery, setSearchQuery] = useState("");

  const fetchNextPage = async (
    pageNum = page,
    query = "",
    sort = sortOrder
  ) => {
    if (loading) return;

    try {
      setLoading(true);
      const newFormats = await getSessionFormatById(
        sessionId,
        pageNum,
        LIMIT,
        query,
        sort
      );

      if (newFormats && Array.isArray(newFormats) && newFormats.length > 0) {
        setDisplayedFormats((prev) => [...prev, ...newFormats]);
        setPage((prev) => prev + 1);
        console.log("Fetched new sessions:", newFormats.length);
      } else {
        console.log("No more sessions to fetch");
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sessionId) {
      fetchNextPage();
      getSessionById(sessionId);
    }
  }, [sessionId]);

  const handleSearch = async (e, sort = sortOrder) => {
    const query = e.target.value;
    setSearchQuery(query);

    try {
      if (query.trim() === "") {
        setDisplayedFormats([]);
        setPage(1);
        setHasMore(true);
        setTimeout(() => {
          fetchNextPage(1, "", sort);
        }, 1);
      } else {
        const newFormats = await getSessionFormatById(
          sessionId,
          1,
          -1,
          query,
          sort
        );
        if (Array.isArray(newFormats)) {
          setDisplayedFormats(newFormats);
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  useEffect(() => {
    if (!sessionStorage.getItem("reloaded")) {
      sessionStorage.setItem("reloaded", "true");
      window.location.reload();
    }
  }, []);

  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };

  const handleEditFormat = (formatId) => {
    navigate(`${adminRoutes.editFormat.replace(":formatId", formatId)}`, {
      state: { sessionId },
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      html: `
        <div style="text-align: center; border-radius: 20px; position: relative;">
          <button
            id="customCloseButton"
            style="position: absolute; top:-5px; right:-10px; background: none; border: none; cursor: pointer;">
            <img
              src=${Close_Button}
              alt="Close"
              style="width: 40px; height: 40px;"
            />
          </button>
          <img
            src=${Suceess}
            alt="Success"
            style="width: 100px; margin-bottom: 10px; margin-top: 15px;"
          />
          <h2 style="color:#151515;text-align:center;font-family:gothambold; font-size:18px;margin-bottom: 10px; ">Are you sure?</h2>
          <p style="color:#2E292A;text-align:center;font-family:gotham_bookregular; line-height:22px; font-size:14px;margin-bottom: 10px; ">
            Do you really want to delete these details? This process cannot be undone.
          </p>
          <button
            id="cancel"
            style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border: none; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Cancel
          </button>
          <br/>
          <button
            id="delete"
            style="background: #800505; color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Delete
          </button>
        </div>
      `,
      showConfirmButton: false,
      width: "400px",
      customClass: {
        popup: "custom-swal-container",
      },
      didOpen: () => {
        const cancel = document.getElementById("cancel");
        const deleteButton = document.getElementById("delete");
        const closeButton = document.getElementById("customCloseButton");

        cancel.addEventListener("click", () => {
          Swal.close();
        });
        deleteButton.addEventListener("click", async () => {
          Swal.close();
          const suceess = await deleteSessionFormat(id);
          if (suceess) {
            window.location.reload(
              `${adminRoutes.listFormat.replace(":sessionId", sessionId)}`
            );
          }
        });

        closeButton.addEventListener("click", () => {
          Swal.close();
        });
      },
    });
  };

  const handleCreateNewFormat = (sessionId) => {
    navigate(adminRoutes.assignFormatFirst.replace(":sessionId", sessionId));
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.session_list_container}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={adminRoutes.dashboard} className={Styles.dark}>
            HOME /
          </Link>{" "}
          <Link to={adminRoutes.listSession} className={Styles.white}>
            {session?.name} /
          </Link>{" "}
          <span>FORMATS</span>
        </h2>
        <div className={Styles.table_container_main}>
          <div className={Styles.table_container}>
            <div className={Styles.table_container_heading}>
              <div className={Styles.table_container_headingone}>
                <h3>FORMAT &nbsp;LIST</h3>
              </div>
              <div className={Styles.table_container_headingtwo}>
                <select
                  className={Styles.sortselect}
                  value={sortOrder}
                  onChange={(e) => {
                    const selected = e.target.value;
                    setSortOrder(selected);
                    setDisplayedFormats([]);
                    setPage(1);
                    setHasMore(true);

                    if (searchQuery.trim()) {
                      handleSearch(
                        { target: { value: searchQuery } },
                        selected
                      );
                    } else {
                      fetchNextPage(1, searchQuery, selected);
                    }
                  }}
                >
                  <option value="oldest">Oldest Formats</option>
                  <option value="latest">Latest Formats</option>

                  <option value="asc">A - Z (Sort in ascending order)</option>
                  <option value="desc">Z - A (Sort in descending order)</option>
                </select>

                <div
                  className={`${Styles.searchContainerchildtwo} ${
                    searchQuery ? Styles.active : ""
                  }`}
                >
                  <FaSearch className={Styles.searchIcon} />
                  <input
                    type="text"
                    className={Styles.searchInput}
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </div>
                <div
                  className={Styles.duplicate}
                  onClick={() => handleCreateNewFormat(sessionId)}
                  style={{ cursor: "pointer" }}
                >
                  <img src={Create} alt="Create Icon" className={Styles.icon} />
                  Create New Format
                </div>
              </div>
            </div>
            <div className={Styles.tableFixedHeader}>
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "10vw" }}>Format</th>
                    <th style={{ width: "18vw" }}>Sub Format</th>
                    <th style={{ width: "26vw" }}>Exercise Name</th>
                    <th style={{ width: "32vw" }}>Actions</th>
                  </tr>
                </thead>
              </table>
              <div id="scrollableDiv" className={Styles.scrollableContainer}>
                <InfiniteScroll
                  dataLength={displayedFormats.length}
                  next={fetchNextPage}
                  hasMore={hasMore}
                  loader={
                    <></>
                  }
                  endMessage={
                    <p style={{  textAlign: "center",
                      padding: "10px",
                      color: "#f3f3f6",
                      fontFamily: "gotham_bookregular",}}>
                      <b>No more Format available</b>
                    </p>
                  }
                  scrollableTarget="scrollableDiv"
                  scrollThreshold={0.8}
                >
                  <table>
                    <tbody>
                      {displayedFormats.length === 0 ? (
                        <tr>
                          <td
                            colSpan="4"
                            style={{ textAlign: "center",
                              padding: "10px",
                              color: "#f3f3f6",
                              fontFamily: "vanguard_cf_regular", }}
                          >
                            {loading
                              ? "Loading Formats..."
                              : "No Formats available"}
                          </td>
                        </tr>
                      ) : (
                        displayedFormats.map((session, index) => (
                          <tr key={session._id || index}>
                            <td style={{ width: "11vw" }}>
                              {capitalizeEachWord(session?.format?.name)}
                            </td>
                            <td style={{ width: "20vw" }}>
                              {capitalizeEachWord(session?.subFormat)}
                            </td>
                            <td style={{ width: "30vw" }}>
                              {session.exercises?.length > 0
                                ? session.exercises.map((ex) => (
                                    <span
                                      key={ex._id}
                                      style={{
                                        display: "inline-block",
                                        marginRight: "2px",
                                        marginBottom: "6px",
                                      }}
                                    >
                                      {ex.exercise?.name}
                                    </span>
                                  ))
                                : "No Exercises"}
                            </td>
                            <td
                              className={Styles.action_buttons}
                              style={{ width: "20vw" }}
                            >
                              <button
                                className={Styles.edit}
                                onClick={() => handleEditFormat(session._id)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                >
                                  <path
                                    d="M12.6786 4.98549L13.8467 3.81735C14.4918 3.17221 15.5378 3.17221 16.183 3.81735C16.8281 4.46249 16.8281 5.50848 16.183 6.15362L15.0148 7.32175M12.6786 4.98549L5.81702 11.8471C4.94594 12.7182 4.51038 13.1537 4.2138 13.6844C3.91722 14.2152 3.61883 15.4684 3.3335 16.6668C4.5319 16.3815 5.78515 16.0831 6.3159 15.7865C6.84665 15.4899 7.2822 15.0544 8.15329 14.1833L15.0148 7.32175M12.6786 4.98549L15.0148 7.32175"
                                    stroke="#F3F3F6"
                                    stroke-width="1.25"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M9.1665 16.6665H14.1665"
                                    stroke="#F3F3F6"
                                    stroke-width="1.25"
                                    stroke-linecap="round"
                                  />
                                </svg>
                                Edit Format
                              </button>
                              <button
                                className={Styles.delete}
                                onClick={() => handleDelete(session._id)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10"
                                  height="10"
                                  viewBox="0 0 10 10"
                                  fill="none"
                                  style={{ marginRight: "5px" }}
                                >
                                  <path
                                    d="M9.16667 0.916504L1 9.08318M1 0.916504L9.16667 9.08318"
                                    stroke="#F3F3F6"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormatList;
